__webpack_require__.p = "https://smartstatus-cms.openxcell.dev/";